import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'rankRoute'
})
export class RankRoutePipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    const rank = Number(value) || -1;
    return rank >= 0 ? `${rank} %` : '';
  }

}
